export default __webpack_public_path__ + "static/media/Account_profile_call.dd5f5a80.svg";